// @ts-nocheck
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import FormInput from "components/Inputs/FormInput";
import React, {useState} from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import "./FormRangeOption.css";
import { t } from "i18next";
import { answerValue } from "classes/Forms/FormAnswerModel";

export default function FormRangeOption({answers, option, onChange}) {
	const {minValue: MinValue, maxValue: MaxValue} = option;
	const [value, setValue] = useState(answers?.length ? parseInt(answerValue(answers[0])) : MinValue);
	const [Error, setError] = useState(checkValue(value));
	
	function checkValue(val) {
		if (val < MinValue || val > MaxValue)
			return(t("Forms.FORM_ANSWER_OUT_OF_RANGE", {min: MinValue, max: MaxValue}))
		return (false);
	}

	function handleChange(val) {
		setError(checkValue(val))
		checkValue(val);
		setValue(val);
		onChange({
			...option,
			value: val,
			unique: true
		});
	}

	return (
		<div>
			<ErrorsCont errors={Error}/>
			{
				(answers?.length && (answerValue(answers[0]) || answerValue(answers[0]) === 0)) ?
					<div>
						{t("Forms.YOUR_ANSWER")}:
						<FormInput
							externvalue={"true"}
							type="number"
							min={MinValue}
							max={MaxValue}
							className="font-bold"
							value={value}
							onChange={handleChange}
						/>
					</div>
				: 
					t("Forms.FORM_SELECT_VALUE")
			}
			<div className="w-100 my-4">
				<InputRange
					onChange={handleChange}
					value={value}
					className="w-100"
					type="range"
					minValue={MinValue}
					maxValue={MaxValue}
					step={1}
				/>
			</div>
		</div>
	);
}

export function formRangOptionChecker(answers, options) {
	let option = options[0];
	let check = answers.find((a) => {
		let val = Number(answerValue(a));
		return (val < option.minValue || val > option.maxValue)
	})
	if (check)
	return(t("Forms.FORM_ANSWER_OUT_OF_RANGE", {min: option.minValue, max: option.maxValue}))
	return (true);
}
